<form (ngSubmit)="onSubmit()" [formGroup]="form" class="vertical-form">
  <div fxLayout="column" fxLayoutGap="20px">
    <div fxLayout="row" fxLayoutAlign="start" class="box space-bottom" fxLayoutGap="10px">
      <mat-form-field>
        <mat-label>Scheme name</mat-label>
        <input type="text" required matInput placeholder="" formControlName="schemeName" maxlength="50" autocomplete="off">
        @if (!form.get('schemeName').valid) {
          <mat-error>Please enter a valid scheme name</mat-error>
        }
      </mat-form-field>
      <mat-form-field fxFlex="120px">
        <mat-label>Status</mat-label>
        <mat-select required formControlName="status">
          <mat-option value="0">-</mat-option>
          @for (s of schemeStatuses; track s) {
            <mat-option [value]="s.value">{{ s.name }}</mat-option>
          }
        </mat-select>
        @if (!form.get('status').valid) {
          <mat-error>Please enter a valid scheme status</mat-error>
        }
      </mat-form-field>
      <mat-form-field fxFlex="150px">
        <mat-label>Start date</mat-label>
        <input matInput required type="text" [matDatepicker]="startDate" placeholder="" formControlName="startDate" autocomplete="off">
        <mat-datepicker-toggle matSuffix [for]="startDate"></mat-datepicker-toggle>
        <mat-datepicker #startDate></mat-datepicker>
      </mat-form-field>
      <mat-form-field fxFlex="150px">
        <mat-label>End date</mat-label>
        <input matInput required type="text" [matDatepicker]="endDate" placeholder="" formControlName="endDate" autocomplete="off">
        <mat-datepicker-toggle matSuffix [for]="endDate"></mat-datepicker-toggle>
        <mat-datepicker #endDate></mat-datepicker>
      </mat-form-field>
      <mat-form-field>
        <mat-label>Priority</mat-label>
        <input matInput type="number" placeholder="" min="0" step="1" formControlName="priority">
        @if (form.controls.priority.dirty && form.controls.priority.errors?.min) {
          <mat-error>Accept positive integer only</mat-error>
        }
        @if (form.controls.priority.dirty && form.controls.priority.errors?.required) {
          <mat-error>Required field</mat-error>
        }
      </mat-form-field>
    </div>
    <div class="box space-bottom">
      <app-campaign-banner #schemeBanner></app-campaign-banner>
    </div>
    <div class="box space-bottom">
      <app-opener-scheme-rules #schemeRules></app-opener-scheme-rules>
    </div>
    <div class="box space bottom">
      <app-opener-scheme-constraint #schemeConstraint (onFormChanged)="onConstraintFormChange($event)" [constraint]="scheme.constraint"></app-opener-scheme-constraint>
    </div>
    <div class="box space-bottom">
      <app-opener-scheme-location-filters #schemeLocationFilters></app-opener-scheme-location-filters>
    </div>
    <div>
      <lib-button (buttonClick)="onSaveScheme()" [disabled]="this.form.invalid">{{ saveSchemeStatus === 1 ? 'Saving scheme...' : saveSchemeStatus === 2 ? 'Saved scheme' : 'Save scheme' }}</lib-button>
      <lib-button (buttonClick)="onRemoveScheme()">Remove scheme</lib-button>
    </div>
  </div>
</form>